<!-- https://www.figma.com/file/hZ14djvbx5qYuIJwSU7moW/%D0%AD%D0%BB%D0%B5%D0%BC%D0%B5%D0%BD%D1%82%D1%8B-%F0%9F%94%A5?node-id=891%3A100841&t=32oT8k8bk879Atwy-1 -->
<template>
  <div class="spoiler">
    <h3
      v-if="title"
      class="spoiler__title"
    >
      {{ title }}
    </h3>
    <div class="spoiler__btn-wrapp">
      <BaseButtonTransparent
        class="spoiler__btn"
        :class="btnClass"
        :text="btnText"
        :image="arrowPath"
        @click="changeShowState"
      />
    </div>

    <BaseTransitionAnimation name="fade">
      <div
        v-show="spoilerVisible"
        class="spoiler__content"
      >
        <slot />
      </div>
    </BaseTransitionAnimation>
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import BaseButtonTransparent from '~/components/BaseComponents/BaseButtonTransparent.vue';
  import BaseTransitionAnimation from '~/components/BaseComponents/BaseTransitionAnimation.vue';
  import arrowPath from '@/assets/images/svg/arrow.svg?raw';

  export default defineNuxtComponent({
    name: 'BaseSpoiler',
    components: {
      BaseButtonTransparent,
      BaseTransitionAnimation,
    },

    props: {
      title: {
        type: String as PropType<string>,
        default: null,
      },

      button_text: {
        type: String as PropType<string>,
        default: 'Показать ещё',
      },

      button_text_open: {
        type: String as PropType<string>,
        default: 'Скрыть ответ',
      },
    },

    data() {
      return {
        spoilerVisible: false,
      };
    },

    computed: {
      arrowPath: () => arrowPath,
      btnClass(): Record<string, boolean> {
        return {
          'spoiler__btn--active': this.spoilerVisible,
        };
      },

      btnText(): string {
        return this.spoilerVisible ? this.button_text_open : this.button_text;
      },
    },

    methods: {
      changeShowState(): void {
        this.spoilerVisible = !this.spoilerVisible;
      },
    },
  });
</script>

<style lang="scss" scoped>
  @use '~/scss/article' as *;

  .spoiler {
    margin: $spacing-6 0;
    border: 1px solid $stroke-color--1;
    border-left: none;
    border-right: none;
    padding: $spacing-4 0;
    &__title {
      text-align: center;
      color: $mainBlack;
      font-family: $headline-font--1;
      font-weight: 400;
      @include mediumText;
      margin-bottom: $spacing-2;
      @include tablet {
        @include extra-big-text;
      }
    }
    &__btn-wrapp {
      display: flex;
      justify-content: center;
      width: 100%;
    }

    &__btn {
      width: auto;
      margin: 0 auto;
    }

    &__content {
      margin-top: $spacing-4;
      :deep() {
        @include article-elems;
        *:first-child {
          margin-top: 0 !important;
        }

        *:last-child {
          margin-bottom: 0 !important;
        }
      }
    }
  }
  :deep() {
    .btn-transparent__icon {
      transform: rotate(90deg);
      transition: transform 0.2s linear;
    }
    .spoiler__btn--active {
      .btn-transparent__icon {
        transition: transform 0.2s linear;
        transform: rotate(-90deg);
      }
    }
  }
</style>
